import React from 'react'
import { DateFrameList } from '../DateFrameList'
import { DynamicTariffSettingsFormFields } from 'src/Libs/dynamic-tariff-settings/constants'
import { UseFieldArrayRemove } from 'react-hook-form'
import { Field } from 'src/Libs/dynamic-tariff-settings/model'

interface Props {
  fields: Field[]
  remove: UseFieldArrayRemove
  hasWritingRights: boolean
}

/**
 * Component to add variable grid fee settings for dynamic tariff settings form
 */
const VariableGridFeeSettingsForm: React.FC<Props> = ({ fields, remove, hasWritingRights }) => {
  return <DateFrameList name={DynamicTariffSettingsFormFields.GridFees} fields={fields} remove={remove} hasWritingRights={hasWritingRights} />
}

export default VariableGridFeeSettingsForm
